import * as React from 'react';
import { Link } from 'react-router-dom';
import ViewEstimation from './ViewEstimation';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { default as DispatchProps, mapDispatchToProps } from '../../../application/core/DispatchProps';
import UserEstimationRequested from '../../../application/estimations/events/UserEstimationRequested';
import State from '../../../application/core/State';

interface MatchParams {
    estimationId: string;
    customerId: string;
}

interface StateProps {
    prevLocation: string;
}

interface Props extends RouteComponentProps<MatchParams>, DispatchProps, StateProps {
    goBackLink: JSX.Element;
}

class CustomerEstimation extends React.PureComponent<Props> {
    public componentDidMount(): void {
        this.props.dispatch(new UserEstimationRequested(this.props.match.params.estimationId, this.props.match.params.customerId));
    }

    public render(): JSX.Element {
        return this.props.prevLocation === '/admin/integration-panel' ? (
            <ViewEstimation goBackLink={<Link to={`/admin/integration-panel`}> &larr; Back to panel</Link>} />
        ) : (
            <ViewEstimation
                goBackLink={<Link to={`/admin/customers/${this.props.match.params.customerId}`}> &larr; Back to customer</Link>}
            />
        );
    }
}

const mapStateToProps = (state: State): StateProps => ({
    prevLocation: state.application.prevLocation
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CustomerEstimation);



// WEBPACK FOOTER //
// ./src/view/estimations/details/CustomerEstimation.tsx